import { updateAfterAttempt, newPlayerK } from "./elo.js";
import { selectNextQuestion, type SelectOptions } from "./selector.js";
import type { EloRating, Question } from "./types.js";

export type PlayerState = {
  rating: EloRating;
  gamesPlayed: number;
};

const DEFAULT_START_RATING: EloRating = 1200;

export function createPlayer(initialRating: EloRating = DEFAULT_START_RATING): PlayerState {
  return { rating: initialRating, gamesPlayed: 0 };
}

export function applyAnswer(
  player: PlayerState,
  question: Question,
  choiceIndex: number,
  weight: number = 1
): { player: PlayerState; question: Question; correct: boolean } {
  const correct = choiceIndex === question.correctIndex;
  const w = Math.max(0, Math.min(1, weight));
  const k = newPlayerK(32, player.gamesPlayed) * w;
  const { player: newR, question: newQR } = updateAfterAttempt(
    player.rating,
    question.rating,
    correct,
    k
  );
  const updatedQuestion: Question = { ...question, rating: newQR };
  const nextPlayer: PlayerState = {
    rating: newR,
    gamesPlayed: player.gamesPlayed + 1,
  };
  return { player: nextPlayer, question: updatedQuestion, correct };
}

export function nextQuestion(
  allQuestions: readonly Question[],
  player: PlayerState,
  options?: SelectOptions
): Question | null {
  return selectNextQuestion(allQuestions, player.rating, options);
}

/** Returns a new array with the question of matching `id` replaced (for persisting difficulty drift). */
export function withUpdatedQuestion(questions: readonly Question[], updated: Question): Question[] {
  return questions.map((q) => (q.id === updated.id ? updated : q));
}
